import { render } from "./TransportContainerRequisiteCreateEditDialog.vue?vue&type=template&id=0a71b8f5&scoped=true&ts=true"
import script from "./TransportContainerRequisiteCreateEditDialog.vue?vue&type=script&lang=ts"
export * from "./TransportContainerRequisiteCreateEditDialog.vue?vue&type=script&lang=ts"

import "./TransportContainerRequisiteCreateEditDialog.vue?vue&type=style&index=0&id=0a71b8f5&scoped=true&lang=css"

import exportComponent from "D:\\Work\\АСУП\\OptiLoadingPaper\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a71b8f5"]])

export default __exports__